import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ProductModel } from '../../../models/master-data/products.model';
import { Observable } from 'rxjs/Observable';
import { CashSaleModel, ProductCashSale } from '../../../models/consultation/cash-sale.model';
import { ProductCategoryUrl } from '../../../shared/urls/master-data.productcategory.url'
import { InvoiceUrl } from '../../../shared/urls/invoice.url'
import { Utility } from '../../../common/utility';
import { ProductUrl } from '../../../shared/urls/master-data.product.url'

@Injectable()
export class ProductService {
    constructor(public baseService: BaseService) {
    }

    getProductsById(categoryId: string) {
        const url = ProductUrl.PRODUCT_GET_ALL;
        return this.baseService.getData(url, { selectedCategory: categoryId, isHasPrice: true });
    }
    getAllProductCategories() {
        const url = ProductCategoryUrl.PRODUCTCATEGORY_GET_ALL;
        return this.baseService.getData(url);
    }
    searchProductName(name: string) {
        const url = ProductUrl.PRODUCT_GET_ALL;
        return this.baseService.getData(url, { searchKey: name, isHasPrice: true }, false);
    }

    saveProduct(productCashSale: any, consultationId: any, invoiceId: any) {
        if (consultationId && invoiceId) {
            const url = Utility.stringFormat(InvoiceUrl.ADD_INVOICE_PRODUCT, [invoiceId]);
            return this.baseService.postData(url, productCashSale);
        }
        const url = InvoiceUrl.ADD_CASH_SALE_PRODUCT;
        return this.baseService.postData(url, productCashSale);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/product-popup.service.ts